import respImgQuery from '../resp-img';

export default`
  ... on FinanceOffer {
    id
    acf_finance_offer {
      fOfferBannerText
      fOfferBannerTitle
      fOfferCtasRep {
        fOfferCtasRepColour
        fOfferCtasRepLink {
          target
          title
          url
        }
      }
      fOfferKeyPointsRep {
        fOfferKeyPointsRepDescription
        fOfferKeyPointsRepDisclaimer
        fOfferKeyPointsRepMainText
        fOfferKeyPointsRepSuperText
      }
      fOfferBannerImage {
        ${respImgQuery}
      }
    }
    acf_finance_offer_nz {
      fOfferBannerTextNz
      fOfferBannerTitleNz
      fOfferCtasRepNz {
        fOfferCtasRepColour
        fOfferCtasRepLink {
          target
          title
          url
        }
      }
      fOfferKeyPointsRepNz {
        fOfferKeyPointsRepDescription
        fOfferKeyPointsRepDisclaimer
        fOfferKeyPointsRepMainText
        fOfferKeyPointsRepSuperText
      }
      fOfferBannerImageNz {
        ${respImgQuery}
      }
    }
  }
`